import HeartRateZoneEditor from './HeartRateZoneEditor'

export default HeartRateZoneEditor
